import { Button, FormInstance } from 'antd'
import React, { FunctionComponent, useCallback, useMemo } from 'react'

import { BuybackFormValues, buybackSteps } from '../../../common/buybackTypes'
import { BuybackFormFooterSaveButton } from '../BuybackFormFooterSaveButton/BuybackFormFooterSaveButton'

export interface BuybackFormFooterProps {
  current: number
  setCurrent: (n: number) => void
  form?: FormInstance<BuybackFormValues>
}

const stepsLength = buybackSteps.length

export const BuybackFormFooter: FunctionComponent<BuybackFormFooterProps> = ({
  current,
  setCurrent,
  form,
}) => {
  const isLastStep = useMemo(() => current === stepsLength - 1, [current])

  const goPrev = useCallback(
    () => setCurrent(Math.max(0, current - 1)),
    [current, setCurrent]
  )
  const goNext = useCallback(
    () => setCurrent(Math.min(stepsLength - 1, current + 1)),
    [current, setCurrent]
  )

  return (
    <div className="flex flex-wrap gap-y-2 space-x-2 justify-end mt-4">
      <Button onClick={goPrev} disabled={current == 0}>
        Předchozí krok
      </Button>

      <Button type="primary" disabled={isLastStep} onClick={goNext}>
        Další krok
      </Button>

      <BuybackFormFooterSaveButton isLastStep={isLastStep} form={form} />
    </div>
  )
}
